export const SEK = new Intl.NumberFormat("sv-SE", {
  style: "currency",
  currency: "SEK",
  maximumFractionDigits: 2,
});

export function formatSEK(n) {
  if (n == null || isNaN(n)) return "0 kr";
  return SEK.format(Number(n));
}

export function todayISO() {
  const d = new Date();
  const tz = d.getTimezoneOffset() * 60000;
  return new Date(d.getTime() - tz).toISOString().slice(0, 10);
}

export function isoFromDate(d) {
  const tz = d.getTimezoneOffset() * 60000;
  return new Date(d.getTime() - tz).toISOString().slice(0, 10);
}

export function rangePreset(key) {
  const now = new Date();
  const end = isoFromDate(now);
  let start;
  switch (key) {
    case "today":
      start = end;
      break;
    case "week": {
      const d = new Date(now);
      const day = (d.getDay() + 6) % 7; // Monday-based week
      d.setDate(d.getDate() - day);
      start = isoFromDate(d);
      break;
    }
    case "month": {
      const d = new Date(now.getFullYear(), now.getMonth(), 1);
      start = isoFromDate(d);
      break;
    }
    case "quarter": {
      const q = Math.floor(now.getMonth() / 3);
      const d = new Date(now.getFullYear(), q * 3, 1);
      start = isoFromDate(d);
      break;
    }
    case "year": {
      const d = new Date(now.getFullYear(), 0, 1);
      start = isoFromDate(d);
      break;
    }
    case "all":
    default:
      return { start: null, end: null };
  }
  return { start, end };
}
